import { render } from "./samTooltip.vue?vue&type=template&id=081ee669&scoped=true"
import script from "./samTooltip.vue?vue&type=script&lang=js"
export * from "./samTooltip.vue?vue&type=script&lang=js"

import "./samTooltip.vue?vue&type=style&index=0&id=081ee669&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-081ee669"]])

export default __exports__